import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import { backstoryTheme } from './BackstoryTheme';
import { BrowserRouter as Router } from 'react-router-dom';
import { BackstoryApp } from './BackstoryApp';
// import { BackstoryTestApp } from 'TestApp';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={backstoryTheme}>
      <Router>
        <BackstoryApp />
        {/* <BackstoryTestApp /> */}
      </Router>
    </ThemeProvider>
  </React.StrictMode>
);
